import { render } from "./PledgeDefinitionList.vue?vue&type=template&id=06ff15f0&scoped=true"
import script from "./PledgeDefinitionList.vue?vue&type=script&lang=js"
export * from "./PledgeDefinitionList.vue?vue&type=script&lang=js"

import "./PledgeDefinitionList.vue?vue&type=style&index=0&id=06ff15f0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff15f0"]])

export default __exports__